import Component from 'component';

class Form extends Component {
  constructor(el, config) {
    super(el, config);
  }

  setupDefaults() {
    this.dom = {
      $formLevelErrorContainer: this.$el.prev('.form__global-error')
    };
  }

  displayFormLevelError(errorMessage) {
    if (typeof this.dom.$formLevelErrorContainer === 'undefined' || this.dom.$formLevelErrorContainer.length === 0) {
      $('<div class="form__global-error"></div>').insertBefore(this.$el);
      this.dom.$formLevelErrorContainer = this.$el.prev('.form__global-error').append(`<p>${errorMessage}</p>`);
    } else {
      this.dom.$formLevelErrorContainer.append(`<p>${errorMessage}</p>`);
    }
  }

  clearFormLevelError() {
    if (this.dom.$formLevelErrorContainer.length > 0) {
      this.dom.$formLevelErrorContainer.html('');
    }
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/tc/js/components/Form.js